// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1YS4v";
var _4 = "selected-262nB";
var _5 = "leftBlock-3W-EB";
var _6 = "includedIcon-2232V";
var _7 = "infoBlock-3MFSD";
var _8 = "title-3UqJd";
var _9 = "description-3FZjh";
var _a = "iconButton-2_hKd";
var _b = "fileBlock-1qRcU";
var _c = "files-3S9LH";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "selected", _5 as "leftBlock", _6 as "includedIcon", _7 as "infoBlock", _8 as "title", _9 as "description", _a as "iconButton", _b as "fileBlock", _c as "files" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "selected": _4, "leftBlock": _5, "includedIcon": _6, "infoBlock": _7, "title": _8, "description": _9, "iconButton": _a, "fileBlock": _b, "files": _c }
